import { formatUrl } from "../../_helpers/parseurl";

export const CourseUnit = ({ handleClick, course }) => {
    return (
        <div
            className="course-unit"
            onClick={handleClick}
        >
            <img className="course-img" src={formatUrl(course?.poster)} alt="" />
            <div className="course-info">
                <div className="course-caption">{course?.title}</div>
                <div className="course-slogan">{course?.slogan}</div>
                <div className="instr">{course?.instructor}</div>
                <div className="course-cat">
                    <img src={formatUrl(course?.categoryId?.icon)} alt="" width={16} />
                    <span className="cat-descr">{course?.categoryId?.title}</span>
                </div>

            </div>
        </div>
    )
}